import styles from './MobilePriceFilter.module.scss';

interface MobilePriceFilterProps {
  fromValue?: number;
  toValue?: number;
  onChange: (fromValue?: number, toValue?: number) => void;
  placeholderStart: string;
  placeholderEnd: string;
}

export const MobilePriceFilter: React.FC<MobilePriceFilterProps> = ({
  fromValue,
  toValue,
  onChange,
  placeholderStart,
  placeholderEnd,
}) => {
  const handleFromChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value ? parseInt(e.target.value, 10) : undefined;
    onChange(value, toValue);
  };

  const handleToChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value ? parseInt(e.target.value, 10) : undefined;
    onChange(fromValue, value);
  };

  return (
    <div className={styles.priceInputs}>
      <div className={styles.inputGroup}>
        <label className={styles.inputLabel}>От</label>
        <div className={styles.inputWrapper}>
          <input
            type='number'
            className={styles.priceInput}
            placeholder={placeholderStart}
            min='0'
            value={fromValue || ''}
            onChange={handleFromChange}
          />
        </div>
      </div>

      <div className={styles.inputGroup}>
        <label className={styles.inputLabel}>До</label>
        <div className={styles.inputWrapper}>
          <input
            type='number'
            className={styles.priceInput}
            placeholder={placeholderEnd}
            min='0'
            value={toValue || ''}
            onChange={handleToChange}
          />
        </div>
      </div>
    </div>
  );
};
